module.exports = __webpack_public_path__ + "assets/img/1.53705e7b.svg";